import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileService, ApiService } from '../../_services'
import { IStoreDrawing, ITag } from '../../_entities';
import { FileBase } from './file-base';

@Component({
	selector: 'file-drawings',
	template: require('./drawing.component.html')
})
export class DrawingComponent extends FileBase {

	constructor(
		private fileService: FileService,
		private api: ApiService) {
		super();
		this.api.tags.getDrawingTags().then(tags => {
			this.tags = tags;
			this.selectedTags = this.tags.concat();
			this.tagFilter = this.tags.map(x => x.id);

		});
	}

	revisions: any[] = [{ id: 'A' }, { id: 'B' }, { id: 'C' }];

	tags: ITag[];

	selectedTags: any[];

	tagFilter: number[];
	
	typeFilter: string = "";
	
	@Input() enableUpload: boolean = false;

	@Input() portletColor: string;

	@Input() uploadUrl: string;

	@Input() files: IStoreDrawing[];

	@Input() tag: string;

	@Output('onUploaded') onUploadedCallback = new EventEmitter();

	@Output('onDeleted') onDeletedCallback = new EventEmitter();

	@Output('onChange') onChangeCallback = new EventEmitter();

	confirmDelete(id, event) {
		this.fileService.deleteFile(id).then(() => {
			this.onDeletedCallback.emit(id);
		});
	}

	onChange(id, event) {
		this.onChangeCallback.emit({ id, event });
	}

	onTagsChange(selected) {
		this.tagFilter = selected.map(x => x.id);
	}
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/file/drawing.component.ts